type NonFalsy<T> = Exclude<T, false | undefined | null | 0 | ''>;

const compact = <T>(array: T[]): NonFalsy<T>[] => array.filter(Boolean) as NonFalsy<T>[];

export default compact;
